import {combineReducers} from '@modifi/redux'

import cmsPageReducer from './cms-page/reducer'
import websiteCmsPageReducer from './website-cms-page/reducer'

export default combineReducers({
  cmsPage: cmsPageReducer,
  websiteCmsPage: websiteCmsPageReducer,
})
